// A read-only context over a committed state, for explain(), validation and the steward
// (24.5: "explain builds a read-only context over state (no draft, no rng)").
import { config, type Config } from '../config';
import { registryFor } from '../content';
import { seasonInfo } from '../core/runner';
import type { GameState, ReadContext, SimMode } from '../core/types';

export function readContext(
  state: GameState,
  cfg: Config = config,
  mode: SimMode = 'live',
): ReadContext {
  return { state, cfg, registry: registryFor(cfg), season: seasonInfo(cfg, state), mode };
}

/** Invariants run in dev and test builds (24.9); production can opt in per call. */
export function defaultCheckInvariants(): boolean {
  const env = (import.meta as { env?: { DEV?: boolean; MODE?: string } }).env;
  return env?.DEV === true || env?.MODE === 'test';
}
